/// <amd-module name="TFS/Admin/Groups/Pivots/Members/Components/MembersPivot" />
import * as React from "react";
import { IPivotProps } from "TFS/Admin/Groups/Common/Contracts";
import { ConnectedMembersPivotInitializer } from "TFS/Admin/Groups/Pivots/Members/Components/MembersPivotInitializer";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";

export class MembersPivot extends VssComponent<IPivotProps> {
    constructor(props: IPivotProps, context: IVssComponentContext) {
        super(props, context);
    }

    public render(): JSX.Element {
        return <ConnectedMembersPivotInitializer filter={this.props.filter} pageContext={this.context.pageContext} />;
    }
}

VssComponent.register("ms.vss-admin-web.orggroups-members-pivot", MembersPivot);
